
export const finance = {
  finance: 'Finance',
  personalFinance: 'Personal Finance',
  dashboard: 'Dashboard',
  overview: 'Overview',
  quickActions: 'Quick Actions',
  financialSummary: 'Financial Summary',
  monthlyTrend: 'Monthly Trend',
  noDataAvailable: 'No data available',
  alerts: 'Alerts',
  more: 'More',
  totalAssets: 'Total Assets',
  totalDebts: 'Total Debts',
  overdue: 'Overdue',
  goal: 'Goal',
  allGood: 'All Good',
  financeDesc: 'Manage your budget, track expenses, and plan your financial future',
  budget: 'Budget',
  expense: 'Expense',
  expenses: 'Expenses',
  income: 'Income',
  savings: 'Savings',
  debts: 'Debts',
  investments: 'Investments',
  reports: 'Reports',
  addTransaction: 'Add Transaction',
  editTransaction: 'Edit Transaction',
  deleteTransaction: 'Delete Transaction',
  amount: 'Amount',
  description: 'Description',
  category: 'Category',
  date: 'Date',
  type: 'Type',
  recurring: 'Recurring',
  balance: 'Balance',
  total: 'Total',
  monthly: 'Monthly',
  yearly: 'Yearly',
  currency: 'Currency',
  exchangeRate: 'Exchange Rate',
  netWorth: 'Net Worth',
  assets: 'Assets',
  liabilities: 'Liabilities',
  cashFlow: 'Cash Flow',
  financialGoals: 'Financial Goals',
  budgetOverview: 'Budget Overview',
  expenseTracking: 'Expense Tracking',
  savingsGoals: 'Savings Goals',
  debtManagement: 'Debt Management',
  investmentPortfolio: 'Investment Portfolio',
  financialReports: 'Financial Reports',
  transactions: 'Transactions',
  debt: 'Debt',
  receivables: 'Receivables',
  calculator: 'Loan Calculator',
  monthlyBalance: 'Monthly Balance',
  monthlyIncome: 'Monthly Income',
  monthlyExpenses: 'Monthly Expenses',
  totalIncome: 'Total Income',
  totalExpenses: 'Total Expenses',
  add: 'Add',
  loading: 'Loading...',
  refreshSession: 'Refresh Session',
  addBudget: 'Add Budget',
  editBudget: 'Edit Budget',
  editBudgetDescription: 'Modify budget name, description and currency.',
  budgetUpdated: 'Budget updated successfully',
  errorUpdatingBudget: 'Error updating budget',
  updating: 'Updating...',
  update: 'Update',
  shareBudget: 'Share Budget',
  deleteBudget: 'Delete Budget',
  selectBudget: 'Select Budget',
  default: 'Default',
  addCategory: 'Add Category',
  
  // Debt translations
  concept: 'Concept',
  debtType: 'Debt Type',
  initialAmount: 'Initial Amount',
  currentBalance: 'Current Balance',
  interestRate: 'Interest Rate',
  installmentAmount: 'Installment Amount',
  startDate: 'Start Date',
  endDate: 'End Date',
  paymentDay: 'Payment Day',
  registerPayment: 'Register Payment',
  registering: 'Registering...',
  selectDate: 'Select Date',
  cancel: 'Cancel',
  numberOfInstallments: 'Number of Installments',
  interestAndPrincipal: 'Interest and Principal',
  interestOnly: 'Interest Only',
  addDebt: 'Add Debt',
  noDebtsRegistered: 'No debts registered',
  
  // Debt completion
  markAsCompleted: 'Mark as paid',
  completedDebts: 'Paid debts',
  activeDebts: 'Active debts',
  showCompletedDebts: 'Show paid debts',
  hideCompletedDebts: 'Hide paid debts',
  debtCompleted: 'Debt paid!',
  debtReactivated: 'Debt reactivated',
  debtReactivatedDesc: 'The debt has been moved back to active',
  confirmCompleteDebt: 'Mark this debt as paid?',
  confirmCompleteDebtDesc: 'This will move the debt to the paid debts section.',
  reactivateDebt: 'Reactivate debt',
  confirmReactivateDebt: 'Reactivate this debt?',
  confirmReactivateDebtDesc: 'This will move the debt back to the active debts section.',
  congratulationsDebtPaid: "Congratulations! You've paid off this debt.",
  paidOn: 'Paid on',
  
  // Receivables translations
  receivableDebtManagement: 'Receivable Debt Management',
  addReceivableDebt: 'Add Receivable Debt',
  receivableDebtSummary: 'Receivable Debt Summary',
  totalReceivables: 'Total Receivables',
  noReceivableDebtsRegistered: 'No receivable debts registered',
  confirmDeleteReceivable: 'Are you sure you want to delete this receivable debt?',
  editReceivableDebt: 'Edit Receivable Debt',
  paymentHistory: 'Payment History',
  paymentAmount: 'Payment Amount',
  maxPaymentAmount: 'Maximum payment amount',
  capitalOnly: 'Capital Only',
  capitalAndInterest: 'Capital and Interest',
  paymentDates: 'Payment Dates',
  noPaymentDates: 'No payment dates',
  actions: 'Actions',
  edit: 'Edit',
  delete: 'Delete',
  saving: 'Saving...',
  save: 'Save',
  
  // Savings translations
  addSavingsGoal: 'Add Savings Goal',
  addDeposit: 'Add Deposit',
  editSavingsGoal: 'Edit Savings Goal',
  deleteSavingsGoal: 'Delete Savings Goal',
  confirmDeleteSavingsGoal: 'Are you sure you want to delete this savings goal?',
  savingsGoalDeleted: 'Savings goal deleted successfully',
  errorDeletingSavingsGoal: 'Error deleting savings goal',
  savingsGoalCreated: 'Savings goal created successfully',
  errorCreatingSavingsGoal: 'Error creating savings goal',
  success: 'Success',
  error: 'Error',
  completed: 'completed',
  progress: 'Progress',
  deadline: 'Deadline',
  selectGoal: 'Select Goal',
  depositAdded: 'Deposit Added',
  depositAddedDesc: 'Your deposit has been added successfully',
  errorAddingDeposit: 'Error Adding Deposit',
  viewMovements: 'View Movements',
  savingsMovements: 'Savings Movements',
  totalDeposits: 'Total Deposits',
  numberOfDeposits: 'Number of Deposits',
  depositHistory: 'Deposit History',
  noDepositsYet: 'No deposits registered yet',
  deletePayment: 'Delete Payment',
  deletePaymentConfirmation: 'This action will permanently delete the payment of',
  madeOn: 'made on',
  
  // Reports translations
  reportsDesc: 'Analyze your finances with detailed monthly and annual reports',
  monthlyReport: 'Monthly Report',
  annualReport: 'Annual Report',
  
  // Export translations
  budgeted: 'Budgeted',
  actual: 'Actual',
  difference: 'Difference',
  summary: 'Summary',
  charts: 'Charts',
  netSavings: 'Net Savings',
  savingsRate: 'Savings Rate',
  budgetVsActual: 'Budget vs Actual',
  
  // Calculator translations
  loanCalculator: 'Loan Calculator',
  loanAmount: 'Loan Amount',
  annualInterestRate: 'Annual Interest Rate (%)',
  termInYears: 'Term in Years',
  calculate: 'Calculate',
  monthlyPayment: 'Monthly Payment',
  totalInterest: 'Total Interest',
  totalPayment: 'Total Payment',
  paymentSchedule: 'Payment Schedule',
  projectedCashFlow: 'Projected Cash Flow',
  basedOnBudget: 'Based on budget',
  projectedIncome: 'Projected Income',
  projectedExpenses: 'Projected Expenses',
  projectedNetFlow: 'Projected Net Flow',
  projectedCashFlowDetails: 'Projected Cash Flow Details',
  selectBudgetForProjectedFlow: 'Select a budget to view projected cash flow',
  actualFlow: 'Actual Flow',
  projectedFlow: 'Projected Flow',
  projectedFlowBasedOnBudget: 'Projected flow based on budget',
  exportProjectedExcel: 'Export Projected Excel',
  noBudgetCategoriesConfigured: 'No budget categories configured for this budget',

  // Calculator Hub Translations
  financialCalculators: 'Financial Calculators',
  financialCalculatorsDesc: 'Use our comprehensive financial calculators to plan your financial future.',
  fundamentalCalculators: 'Fundamental Calculators',
  compoundInterestCalculator: 'Compound Interest Calculator',
  compoundInterestDesc: 'Calculate how your money grows over time with compound interest.',
  savingsGoalCalculator: 'Savings Goal Calculator',
  savingsGoalDesc: 'Plan how much to save each month to reach your financial goals.',
  debtPayoffCalculator: 'Debt Payoff Calculator',
  debtPayoffDesc: 'Compare debt payoff strategies: avalanche vs. snowball method.',
  budgetCalculator: 'Budget Calculator (50/30/20)',
  budgetCalculatorDesc: 'Plan your budget using the popular 50/30/20 rule.',
  loanCalculatorDesc: 'Calculate monthly payments for loans and mortgages.',
  moreCalculatorsComingSoon: 'More Calculators Coming Soon',
  moreCalculatorsDesc: 'We are working on additional calculators including mortgage, retirement, and investment tools.',
  mortgageCalculator: 'Mortgage Calculator',
  mortgageCalculatorDesc: 'Calculate monthly mortgage payments including taxes, insurance, and PMI.',
  retirementCalculator: 'Retirement Calculator',
  inflationCalculator: 'Inflation Calculator',
  back: 'Back',
  
  // Compound Interest Calculator
  inputParameters: 'Input Parameters',
  initialInvestment: 'Initial Investment',
  timeInYears: 'Time in Years',
  compoundingFrequency: 'Compounding Frequency',
  monthlyContribution: 'Monthly Contribution',
  daily: 'Daily',
  weekly: 'Weekly',
  quarterly: 'Quarterly',
  semiannually: 'Semi-annually',
  annually: 'Annually',
  calculationResults: 'Calculation Results',
  totalContributed: 'Total Contributed',
  interestEarned: 'Interest Earned',
  finalBalance: 'Final Balance',
  effectiveAnnualReturn: 'Effective Annual Return',
  exportResults: 'Export Results',
  growthProjection: 'Growth Projection',
  year: 'Year',
  principalContributed: 'Principal Contributed',
  totalValue: 'Total Value',
  
  // Savings Goal Calculator
  savingsGoalParameters: 'Savings Goal Parameters',
  calculationType: 'Calculation Type',
  howLongToReachGoal: 'How long to reach my goal?',
  howMuchToSaveMonthly: 'How much to save monthly?',
  savingsGoal: 'Savings Goal',
  currentSavings: 'Current Savings',
  timeFrameMonths: 'Time Frame (Months)',
  goalProjection: 'Goal Projection',
  timeToGoal: 'Time to Goal',
  monthlyAmount: 'Monthly Amount',
  totalInterestEarned: 'Total Interest Earned',
  requiredMonthlyPayment: 'Required Monthly Payment',
  totalToSave: 'Total to Save',
  timeFrame: 'Time Frame',
  months: 'months',
  savingsProjection: 'Savings Projection',
  month: 'Month',
  totalSaved: 'Total Saved',
  contributions: 'Contributions',
  
  // Debt Payoff Calculator
  yourDebts: 'Your Debts',
  debtName: 'Debt Name',
  minPayment: 'Min Payment',
  extraMonthlyPayment: 'Extra Monthly Payment',
  payoffStrategies: 'Payoff Strategies',
  avalancheMethod: 'Avalanche Method',
  snowballMethod: 'Snowball Method',
  avalancheDescription: 'Pay off debts with highest interest rates first to minimize total interest paid.',
  snowballDescription: 'Pay off smallest debts first to build psychological momentum.',
  payoffTime: 'Payoff Time',
  interestSavings: 'Interest Savings',
  psychologicalWins: 'Psychological Wins',
  payoffOrder: 'Payoff Order',
  debtBreakdown: 'Debt Breakdown',
  
  // Budget Calculator
  budgetSettings: 'Budget Settings',
  customizePercentages: 'Customize Percentages',
  rule503020: '50/30/20 Rule',
  needs: 'Needs',
  wants: 'Wants',
  shouldBe100: 'should be 100%',
  budgetBreakdown: 'Budget Breakdown',
  exportBudget: 'Export Budget',
  budgetVisualization: 'Budget Visualization',
  vsRecommended: 'vs Recommended',
  current: 'Current',
  recommended: 'Recommended',
  detailedNeedsBreakdown: 'Detailed Needs Breakdown',
  housing: 'Housing',
  food: 'Food',
  transportation: 'Transportation',
  utilities: 'Utilities',
  budgetTips: 'Budget Tips',
  tip1: 'Track all expenses for a month to understand your spending patterns',
  tip2: 'Automate savings by setting up automatic transfers to savings accounts',
  tip3: 'Review and adjust your budget monthly based on actual spending',
  tip4: 'Build an emergency fund before focusing on other financial goals',

  // Advanced Trend Analysis
  advancedTrendAnalysis: 'Advanced Trend Analysis',
  trends: 'Trends',
  predictions: 'Predictions',
  insight: 'insight',
  prediction: 'prediction',
  compare: 'Compare',
  
  // Financial Alerts
  financialAlerts: 'Financial Alerts',
  allGoodAlerts: 'All Good!',
  noFinancialAlertsAtMoment: 'No financial alerts at the moment',
  
  // Reports Additional
  export: 'Export',
  ratios: 'Ratios',
  healthScore: 'Health Score',
  healthScoreShort: 'Health',
  insights: 'Insights',
  monthOverMonth: 'Month-over-Month',
  yearToDate: 'Year to Date',
  incomeChange: 'Income Change',
  expenseChange: 'Expense Change',
  savingsChange: 'Savings Change',
  ytdIncome: 'YTD Income',
  ytdExpenses: 'YTD Expenses',
  ytdSavings: 'YTD Savings',
  ytdRate: 'YTD Rate',
  topSpendingCategories: 'Top Spending Categories',
  financialHealthScore: 'Financial Health Score',
  excellent: 'Excellent',
  good: 'Good',
  fair: 'Fair',
  needsImprovement: 'Needs Improvement',
  categoryBreakdown: 'Category Breakdown',
  generatingComprehensiveReport: 'Generating comprehensive report...',
  noSufficientDataForReport: 'No sufficient data for comprehensive report.',
  addCategoriesAndTransactions: 'Add categories and transactions to generate detailed insights.',
  recommendations: 'Recommendations',
  achievements: 'Achievements',
  keyInsights: 'Key Insights',
  warnings: 'Warnings',
  grade: 'Grade',
  
  // Financial Health Widget - Additional translations
  priorityActions: 'Priority Actions',
  financialStrengths: 'Financial Strengths',
  areasForImprovement: 'Areas for Improvement',
  overallAssessment: 'Overall Assessment',
  completedStatus: 'Completed',
  ahead: 'Ahead',
  onTrack: 'On Track',
  behind: 'Behind',
  progressLabel: 'Progress',
  currentLabel: 'Current',
  targetLabel: 'Target',
  timeframeLabel: 'Timeframe',
  overallAssessmentExcellent: 'Your financial health is excellent! Continue your disciplined approach and consider advanced investment strategies.',
  overallAssessmentGood: 'You have good financial health with room for optimization. Focus on your weakest areas for improvement.',
  overallAssessmentFair: 'Your financial health is fair. Address priority actions to build a stronger foundation.',
  overallAssessmentPoor: 'Your financial health needs attention. Focus on emergency fund building and expense control first.',
  incomeStabilityMetric: 'Income Stability',
  score: 'Score',
  poor: 'Poor',
  currentValue: 'Current',
  targetValue: 'Target',
  yearOverYear: 'Year over Year',
  
  // Alerts translations
  budgetExceeded: 'Budget Exceeded',
  budgetExceededMessage: "You've exceeded your {category} budget by {percentage}%",
  budgetWarning: 'Budget Warning',
  budgetWarningMessage: "You've used {percentage}% of your {category} budget",
  paymentDueSoon: 'Payment Due Soon',
  paymentDueSoonMessage: '{concept} payment of ${amount} due in {days} day',
  paymentDueSoonMessagePlural: '{concept} payment of ${amount} due in {days} days',
  overdueDebt: 'Overdue Debt',
  overdueDebtMessage: '{concept} is overdue with ${amount} remaining',
  savingsOpportunity: 'Savings Opportunity',
  savingsOpportunityMessage: 'You have ${amount} left this month. Consider adding it to your savings!',
  goalAchieved: 'Goal Achieved!',
  goalAchievedMessage: "Congratulations! You've completed your {concept} savings goal!",
  savingsGoalDeadlineApproaching: 'Savings Goal Deadline Approaching',
  savingsGoalDeadlineMessage: '{concept} deadline in {days} days. Save ${amount}/day to reach your goal.',
  highExpenseRatio: 'High Expense Ratio',
  highExpenseRatioMessage: 'Your expenses are {percentage}% of your income this month',
  noTransactionsThisMonth: 'No Transactions This Month',
  noTransactionsMessage: 'Start tracking your expenses to get better financial insights',
  actionRequired: 'Action Required',
  actionRequiredMessage: 'You have {count} alert that needs immediate attention.',
  actionRequiredMessagePlural: 'You have {count} alerts that need immediate attention.',
  dayRemaining: 'day remaining',
  daysRemaining: 'days remaining',
  
  // Recurring Transactions
  recurringTransactions: 'Recurring Transactions',
  generateDue: 'Generate Due',
  newTransaction: 'New',
  recurringTab: 'Recurring',
  templatesTab: 'Templates',
  noRecurringTransactionsYet: 'No recurring transactions yet.',
  createOneToAutomateFinances: 'Create one to automate your finances.',
  createRecurringTransaction: 'Create Recurring Transaction',
  templateName: 'Template Name',
  
  // Vouchers
  voucher: 'Voucher',
  voucherLabel: 'Payment Voucher (Optional)',
  voucherShort: 'Doc',
  voucherPreview: 'Voucher Preview',
  voucherView: 'View',
  voucherUploaded: 'Voucher uploaded',
  voucherUploadSuccess: 'Voucher uploaded successfully',
  voucherUploadError: 'Error uploading voucher',
  voucherDeleteSuccess: 'Voucher deleted successfully',
  voucherInvalidFileType: 'Invalid file type',
  voucherAllowedTypes: 'Only images (JPG, PNG, WEBP) and PDF files are allowed',
  voucherFileTooLarge: 'File too large',
  voucherMaxSize: 'Maximum file size is 10MB',
  voucherDragOrClick: 'Attach your invoice, receipt or purchase ticket in image or PDF format',
  voucherDropHere: 'Drop the file here',
  voucherSupportedFormats: 'Accepted formats: JPG, PNG, WEBP or PDF (max 10MB)',
  
  // Filters and table headers
  filterByDate: 'Filter by date',
  filterByDescription: 'Filter by description',
  filterByCategory: 'Filter by category',
  filterBySubcategory: 'Filter by subcategory',
  quantity: 'Quantity',
  noSubcategories: 'No subcategories',
  
  // Financial Health Analysis
  financialHealthAnalysis: 'Financial Health Analysis',
  overviewTab: 'Overview',
  metricsTab: 'Metrics',
  goalsTab: 'Goals',
  insightsTab: 'Insights',
  analyzingYourFinancialHealth: 'Analyzing your financial health...',
  addFinancialDataToSeeHealthScore: 'Add financial data to see your health score.',
  trackIncomeExpensesSavingsToStart: 'Track income, expenses, and savings to get started.',
  
  // Financial Health Status and Metrics
  needsWork: 'Needs Work',
  criticalStatus: 'Critical',
  financialHealth: 'Financial Health',
  yourFinancialWellnessIsStrong: 'Your financial wellness is strong',
  yourFinancialWellnessIsImproving: 'Your financial wellness is improving',
  budgetManagementMetric: 'Budget Management',
  savingsPerformanceMetric: 'Savings Performance',
  debtManagementMetric: 'Debt Management',
  emergencyPreparednessMetric: 'Emergency Preparedness',
  expenseControlMetric: 'Expense Control',
  recentTrends: 'Recent Trends',
  monthlySavingsIncreasing: 'Monthly savings increasing',
  monthlySavingsDecreasing: 'Monthly savings decreasing',
  monthlySavingsStable: 'Monthly savings stable',
  expensesDecreasing: 'Expenses decreasing',
  expensesIncreasing: 'Expenses increasing',
  
  // Phase 2: Housing Calculators
  housingCalculators: 'Housing Calculators',
  mortgageAmount: 'Mortgage Amount',
  downPayment: 'Down Payment',
  downPaymentPercent: 'Down Payment (%)',
  propertyTax: 'Property Tax (Annual)',
  homeInsurance: 'Home Insurance (Annual)',
  pmiRate: 'PMI Rate (%)',
  pmiInfo: 'Private Mortgage Insurance (if down payment < 20%)',
  totalMonthlyPayment: 'Total Monthly Payment',
  principalAndInterest: 'Principal & Interest',
  propertyTaxMonthly: 'Property Tax (Monthly)',
  insuranceMonthly: 'Insurance (Monthly)',
  pmiMonthly: 'PMI (Monthly)',
  mortgageBreakdown: 'Mortgage Breakdown',
  amortizationSchedule: 'Amortization Schedule',
  paymentNumber: 'Payment #',
  principal: 'Principal',
  interest: 'Interest',
  remainingBalance: 'Remaining Balance',
  
  // Rent vs Buy Calculator
  rentVsBuyCalculator: 'Rent vs Buy Calculator',
  rentVsBuyDesc: 'Compare the financial impact of renting versus buying a home.',
  rentVsBuyParameters: 'Rent vs Buy Parameters',
  rentVsBuyComparison: 'Rent vs Buy Comparison',
  homePrice: 'Home Price',
  rentPerMonth: 'Monthly Rent',
  rentEquityBuilt: 'Rent Equity Built',
  buyEquityBuilt: 'Buy Equity Built',
  netWorthComparison: 'Net Worth Comparison',
  after: 'After',
  years: 'years',
  rentIncrease: 'Annual Rent Increase (%)',
  homeAppreciation: 'Home Appreciation (%)',
  yearsToCompare: 'Years to Compare',
  closingCosts: 'Closing Costs',
  maintenanceCosts: 'Maintenance Costs (% of home value)',
  investmentReturn: 'Investment Return (%)',
  taxBenefit: 'Tax Benefit (%)',
  totalCostRenting: 'Total Cost of Renting',
  totalCostBuying: 'Total Cost of Buying',
  netWorthDifference: 'Net Worth Difference',
  recommendation: 'Recommendation',
  buyingIsBetter: 'Buying is better by',
  rentingIsBetter: 'Renting is better by',
  breakEvenYear: 'Break-even Year',
  
  // Phase 3: Investment Calculators
  investmentCalculators: 'Investment Calculators',
  retirementPlanningCalculator: 'Retirement Planning Calculator',
  retirementPlanningDesc: 'Calculate how much you need to save for retirement.',
  retirementParameters: 'Retirement Parameters',
  currentAge: 'Current Age',
  retirementAge: 'Retirement Age',
  currentRetirementSavings: 'Current Retirement Savings',
  monthlyRetirementContribution: 'Monthly Retirement Contribution',
  expectedRetirementReturn: 'Expected Annual Return (%)',
  desiredRetirementIncome: 'Desired Annual Retirement Income',
  inflationRate: 'Expected Inflation Rate (%)',
  retirementYears: 'Years in Retirement',
  retirementProjection: 'Retirement Projection',
  projectedRetirementSavings: 'Projected Retirement Savings',
  retirementIncomeGap: 'Retirement Income Gap',
  additionalSavingsNeeded: 'Additional Savings Needed',
  additionalMonthlySavings: 'Additional Monthly Savings',
  annualIncome: 'annual income',
  retirementOnTrack: 'Your retirement is on track!',
  youCanSafelyWithdraw: 'You can safely withdraw',
  moneyWillLastUntil: 'Money Will Last Until',
  age: 'Age',
  retirementSavingsProjection: 'Retirement Savings Projection',
  
  // Emergency Fund Calculator
  emergencyFundCalculator: 'Emergency Fund Calculator',
  emergencyFundDesc: 'Calculate how much you should save for emergencies.',
  emergencyFundParameters: 'Emergency Fund Parameters',
  monthlyExpensesForEmergency: 'Monthly Essential Expenses',
  includeRentFoodUtilities: 'Include rent, food, utilities, etc.',
  emergencyMonths: 'Months of Expenses to Cover',
  emergencyFundGoal: 'Emergency Fund Goal',
  currentEmergencyFund: 'Current Emergency Fund',
  howMuchCanYouSaveMonthly: 'How much can you save monthly?',
  emergencyFundAnalysis: 'Emergency Fund Analysis',
  emergencyFundShortfall: 'Emergency Fund Shortfall',
  emergencyFundAdequate: 'Your emergency fund is adequate!',
  youHaveExtra: 'You have an extra',
  youNeedAdditional: 'You need an additional',
  atCurrentRate: 'At current rate of',
  youWillReachGoalIn: 'you will reach your goal in',
  currentFund: 'Current Fund',
  monthsToEmergencyGoal: 'Months to Reach Goal',
  emergencyFundRecommendations: 'Emergency Fund Recommendations',
  minimumRecommendation: 'Minimum Recommendation',
  standardRecommendation: 'Standard Recommendation',
  conservativeRecommendation: 'Conservative Recommendation',
  maxRecommendation: 'Maximum Recommendation',
  shortfall: 'Shortfall',
  
  // Investment ROI Calculator
  investmentROICalculator: 'Investment ROI Calculator',
  investmentROIDesc: 'Calculate the return on investment for different scenarios.',
  initialInvestmentAmount: 'Initial Investment',
  additionalInvestments: 'Additional Monthly Investments',
  expectedAnnualReturn: 'Expected Annual Return (%)',
  investmentTimeHorizon: 'Investment Time Horizon (Years)',
  taxRate: 'Tax Rate (%)',
  inflationAdjusted: 'Inflation Adjusted',
  nominalReturn: 'Nominal Return',
  realReturn: 'Real Return (Inflation Adjusted)',
  totalInvestmentValue: 'Total Investment Value',
  totalGains: 'Total Gains',
  afterTaxValue: 'After-Tax Value',
  
  // Net Worth Page translations
  refreshData: 'Refresh Data',
  refresh: 'Refresh',
  dataRefreshed: 'Net worth data updated successfully',
  errorRefreshingData: 'Error refreshing data',
  accountNumber: 'Account Number',
  noBankAccountsRegistered: 'No bank accounts registered',
  deleteAccountConfirmation: 'Are you sure you want to delete this account?',
  cash: 'Cash',
  noCashHoldingsRegistered: 'No cash holdings registered',
  addCashHolding: 'Add Cash Holding',
  totalInvestmentsValue: 'Total Investments Value',
  showDistribution: 'Show Distribution',
  hideDistribution: 'Hide Distribution',
  assetDistribution: 'Asset Distribution',
  manageYourInvestments: 'Manage your investment portfolio',
  netWorthSummary: 'Net Worth Summary',
  positive: 'Positive',
  negative: 'Negative',
  assetsVsLiabilities: 'Assets vs Liabilities',
  bankAccountsAndCash: 'Bank Accounts & Cash',
  addBankAccount: 'Add Bank Account',
  investmentAdded: 'Investment added successfully',
  errorSavingInvestment: 'Error saving investment',
  investmentUpdated: 'Investment updated successfully',
  errorUpdatingInvestment: 'Error updating investment',
  investmentDeleted: 'Investment deleted successfully',
  errorDeletingInvestment: 'Error deleting investment',
  symbol: 'Symbol',
  purchasePrice: 'Purchase Price',
  currentPrice: 'Current Price',
  profitLoss: 'Profit/Loss',
  bankName: 'Bank Name',
  bankNameRequired: 'Bank name is required',
  accountNumberRequired: 'Account number is required',
  balanceMustBeNumber: 'Balance must be a number',
  allFieldsRequired: 'All fields are required',
  accountUpdated: 'Bank account updated successfully',
  accountAdded: 'Bank account added successfully',
  errorSavingAccount: 'Error saving bank account',
  bankAccountUpdated: 'Bank account updated successfully',
  errorUpdatingBankAccount: 'Error updating bank account',
  customCurrency: 'Custom Currency',
  customCurrencyCode: 'Custom Currency Code',
  currencyCodeRequired: '3-letter currency code required',
  currencyCodeHint: 'Use 3-letter ISO currency code',
  selectCurrency: 'Select currency',
  validNumberRequired: 'Please enter a valid number',
  balanceRequired: 'Balance is required',
  invalidAmount: 'Please enter a valid amount',
  propertyUpdated: 'Property updated successfully',
  errorUpdatingProperty: 'Failed to update property',
  deletePropertyConfirmation: 'Are you sure you want to delete this property?',
  noPropertiesRegistered: 'No properties registered',
  propertyDescriptionPlaceholder: 'Property description',
  descriptionRequired: 'Description is required',
  selectPropertyType: 'Select property type',
  propertySizeRequired: 'Property size is required',
  propertyValueRequired: 'Property value is required',
  annualAppreciationRequired: 'Annual appreciation is required',
  invalidNumber: 'Please enter valid numbers for size, value, and appreciation rate',
  size: 'Size',
  assetUpdated: 'Asset updated successfully',
  errorUpdatingAsset: 'Error updating asset',
  confirmDelete: 'Are you sure you want to delete this asset?',
  noAssetsAdded: 'No assets added yet',
  
  // Enhanced Investment Types
  listedSecurities: 'Listed Securities',
  fundsLabel: 'Funds',
  privateInvestments: 'Private Investments',
  privateEquity: 'Private Equity',
  ventureCapital: 'Venture Capital',
  realEstateFund: 'Real Estate Fund (REIT)',
  fixedIncome: 'Fixed Income',
  certificateDeposit: 'Certificate of Deposit',
  p2pLending: 'P2P Lending',
  otherInvestments: 'Other',
  commodity: 'Commodity',
  forex: 'Forex',
  
  // Stock Details
  stockDetails: 'Stock Details',
  tickerSymbol: 'Ticker Symbol',
  exchange: 'Exchange',
  selectExchange: 'Select exchange',
  otherExchange: 'Other',
  autoUpdate: 'Auto-update',
  autoUpdateDescription: 'Automatically update price via API',
  
  // Sectors
  sector: 'Sector',
  selectSector: 'Select sector',
  sectorTechnology: 'Technology',
  sectorHealthcare: 'Healthcare',
  sectorFinance: 'Finance',
  sectorConsumer: 'Consumer',
  sectorEnergy: 'Energy',
  sectorUtilities: 'Utilities',
  sectorRealEstate: 'Real Estate',
  sectorMaterials: 'Materials',
  sectorIndustrials: 'Industrials',
  sectorCommunications: 'Communications',
  
  // Financial Details
  financialDetails: 'Financial Details',
  investmentNamePlaceholder: 'e.g., Apple Inc.',
  providerPlaceholder: 'e.g., Fidelity, Schwab',
  investmentNotesPlaceholder: 'Add any personal notes about this investment...',
  notes: 'Notes',
  
  // Dividends
  dividends: 'Dividends',
  dividendYield: 'Dividend Yield',
  dividendRecord: 'Dividend Record',
  addDividend: 'Add Dividend',
  
  // Investment Transactions
  investmentTransactions: 'Transactions',
  transactionType: 'Transaction Type',
  buy: 'Buy',
  sell: 'Sell',
  dividend: 'Dividend',
  split: 'Stock Split',
  fees: 'Fees',
  transactionDate: 'Transaction Date',
  
  // Stock Price Updates
  updatePrices: 'Update Prices',
  updatingPrices: 'Updating...',
  pricesUpdated: 'Prices Updated',
  investmentsUpdated: 'investment(s) updated successfully',
  noAutoUpdateInvestments: 'No investments to update',
  noAutoUpdateInvestmentsDesc: 'Enable auto-update on investments with ticker symbols to use this feature.',
  errorUpdatingPrices: 'Failed to update prices',
  lastPriceUpdate: 'Last price update',
  allPricesUpToDate: 'All prices are already up to date.',
  noUpdatesNeeded: 'No updates needed',
  updatePartialError: 'Update completed with errors',
  manualPricing: 'Manual pricing',
  neverUpdated: 'Never updated',
  lastUpdated: 'Updated',
  
  // Investment categories
  allInvestments: 'All',
  noInvestmentsInCategory: 'No investments in this category',
  
  // Phase 4: Transactions & Dividends
  transactionAddedSuccess: 'Transaction added successfully',
  errorAddingTransaction: 'Error adding transaction',
  deleteTransactionConfirmation: 'Are you sure you want to delete this transaction?',
  transactionDeleted: 'Transaction deleted successfully',
  errorDeletingTransaction: 'Error deleting transaction',
  noTransactionsYet: 'No transactions recorded yet',
  dividendAdded: 'Dividend added successfully',
  errorAddingDividend: 'Error adding dividend',
  deleteDividendConfirmation: 'Are you sure you want to delete this dividend?',
  dividendDeleted: 'Dividend deleted successfully',
  errorDeletingDividend: 'Error deleting dividend',
  noDividendsYet: 'No dividends recorded yet',
  totalDividends: 'Total Dividends',
  ytdDividends: 'YTD Dividends',
  paymentDate: 'Payment Date',
  
  // Performance Metrics
  portfolioPerformance: 'Portfolio Performance',
  totalProfitLoss: 'Total Profit/Loss',
  totalReturn: 'Total Return',
  winRate: 'Win Rate',
  winners: 'Winners',
  losers: 'Losers',
  bestPerformer: 'Best Performer',
  worstPerformer: 'Worst Performer',
  
  // Add Investment Dialog
  addInvestment: 'Add Investment',
  editInvestment: 'Edit Investment',
  investmentType: 'Investment Type',
  selectType: 'Select type',
  stock: 'Stock',
  bond: 'Bond',
  mutualFund: 'Mutual Fund',
  etf: 'ETF',
  cryptocurrency: 'Cryptocurrency',
  pricePerUnit: 'Price Per Unit',
  purchaseDate: 'Purchase Date',
  provider: 'Provider',
  name: 'Name',
  other: 'Other',
  
  // Net Worth - Properties
  properties: 'Properties',
  addProperty: 'Add Property',
  deleteProperty: 'Delete Property',
  propertyType: 'Property Type',
  house: 'House',
  apartment: 'Apartment',
  land: 'Land',
  commercial: 'Commercial',
  
  // Net Worth - Other Assets
  otherAssets: 'Other Assets',
  addAsset: 'Add Asset',
  
  // Investments Summary
  viewDetails: 'View Details',
  distributionByType: 'Distribution by Type',
  
  // Net Worth Summary
  totalLiabilities: 'Total Liabilities',
  bankAccounts: 'Bank Accounts',
  noLiabilities: 'No liabilities registered',
  currencyBreakdown: 'Currency Breakdown',
  equivalent: 'Equivalent',
  exchangeRates: 'Exchange Rates',
  updateRates: 'Update Rates',
  never: 'Never',
  unknown: 'Unknown',
};
